module.exports = __webpack_public_path__ + "media/images/prescreened-experts-10f509c21aaee10b1b6c83449a8b5d1ac7726ac18050bc2bf5675b7cc7129d04.jpg";